/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ set: NonNullable<unknown>, day: NonNullable<unknown> }} Exercise_Sheet_Record_WhenInputs */

const en_us2_exercise_sheet_record_when = /** @type {(inputs: Exercise_Sheet_Record_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.set} · ${i?.day}`)
};

const pt_br2_exercise_sheet_record_when = /** @type {(inputs: Exercise_Sheet_Record_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.set} · ${i?.day}`)
};

const es_419_exercise_sheet_record_when = /** @type {(inputs: Exercise_Sheet_Record_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.set} · ${i?.day}`)
};

const pt_pt2_exercise_sheet_record_when = /** @type {(inputs: Exercise_Sheet_Record_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.set} · ${i?.day}`)
};

const fr_fr2_exercise_sheet_record_when = /** @type {(inputs: Exercise_Sheet_Record_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.set} · ${i?.day}`)
};

const de_de2_exercise_sheet_record_when = /** @type {(inputs: Exercise_Sheet_Record_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.set} · ${i?.day}`)
};

const it_it2_exercise_sheet_record_when = /** @type {(inputs: Exercise_Sheet_Record_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.set} · ${i?.day}`)
};

/**
* | output |
* | --- |
* | "{set} · {day}" |
*
* @param {Exercise_Sheet_Record_WhenInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_record_when = /** @type {((inputs: Exercise_Sheet_Record_WhenInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Record_WhenInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_record_when(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_record_when(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_record_when(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_record_when(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_record_when(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_record_when(inputs)
	return en_us2_exercise_sheet_record_when(inputs)
});
export { exercise_sheet_record_when as "exercise-sheet.record_when" }